export { TrustPilotPhrase } from "./TrustPilotPhrase"
